import request from '@/utils/request'

// 分页查询（使用本地启动的 masterdata-api 服务地址）
export const getTableData = params =>
  request.post('/masterdata-api/thirdKey/page', params)

// 新增
export const addThirdKey = params => request.post('/masterdata-api/thirdKey/add', params)

// 更新（apiKey 在路径中）
export const updateThirdKey = (apiKey, params) =>
  request.post(`/masterdata-api/thirdKey/update/${apiKey}`, params)

// 物理删除
export const deleteThirdKey = apiKey =>
  request.get(`/masterdata-api/thirdKey/delete/${apiKey}`)

// 失效
export const invalidateThirdKey = (apiKey, params) =>
  request.post(`/masterdata-api/thirdKey/invalidate/${apiKey}`, params)

// 启用
export const enableThirdKey = apiKey =>
  request.get(`/masterdata-api/thirdKey/enable/${apiKey}`)
